export const pdfcss = (function () {
  return `
    html, body.kt-subheader--transparent {font-size:16px !important;}
    .row:after {content:"";display:table;clear:both;}
    .kt-content {padding: 0 !important}
    #productApprovalCard-full {font-size:1rem !important;font-weight:400 !important}
    .kt-badge--bbw-color {display:inline-block}
  `;
})();
